import { useEffect } from "react";

export default function Toast({ message, onClose }: { message: string; onClose: () => void }) {
  useEffect(() => {
    const timer = window.setTimeout(onClose, 2400);
    return () => window.clearTimeout(timer);
  }, [message, onClose]);

  return (
    <div className="fixed bottom-6 left-1/2 z-[95] -translate-x-1/2">
      <div className="animate-fade-up flex items-center gap-2 rounded-full bg-foreground-950 px-4 py-2.5 text-sm text-background-50">
        <i className="ri-checkbox-circle-fill text-accent-400" />
        <span className="whitespace-nowrap">{message}</span>
      </div>
    </div>
  );
}